import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_EULA_DETAILS } from './url-constants';

type GetEulaDetailsEndpointSpecification = ApiEndpointSpecification;
export const GetEulaDetailsEndpointSpecification: GetEulaDetailsEndpointSpecification = {
    url: GET_EULA_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetEulaDetailsRequestParams',
    requestBodySchemaName: 'GetEulaDetailsRequestBody',
    okResponseSchemaName: 'GetEulaDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    // version: 2,
};

export const invokeGetEulaDetails = Helpers.makeApiRequestFn<
    Types.GetEulaDetailsRequestParams,
    Types.GetEulaDetailsRequestBody,
    Types.GetEulaDetailsOkResponse
>(GetEulaDetailsEndpointSpecification);
